import ApprovedUsersTable from './ApprovedUsersTable';
export default ApprovedUsersTable;